import { createSlice } from "@reduxjs/toolkit";
import {
  closingsOverviewMonth,
  closingsOverviewCommunity,
  closingsOverviewQuarter,
  closingsMyConciergeOverviewBuyers,
} from "../../utils/fields";

const getClosingsOverviewMonth = Object.values(closingsOverviewMonth);
const getClosingsOverviewCommunity = Object.values(closingsOverviewCommunity);
const getClosingsOverviewQuarter = Object.values(closingsOverviewQuarter);
const getClosingsMyConciergeOverviewBuyers = Object.values(
  closingsMyConciergeOverviewBuyers
);

const storageAdminSettings = "adminSettings";

const parseAction = (payload) => {
  return JSON.parse(JSON.stringify(payload));
};

const setStorageSettings = (settings) => {
  localStorage.setItem(storageAdminSettings, JSON.stringify(settings));
};

export const AdminSettingsSlice = createSlice({
  name: "adminSettings",
  initialState: localStorage.getItem(storageAdminSettings)
    ? JSON.parse(localStorage.getItem(storageAdminSettings))
    : {
        closingsOverviewMonth: {
          masterList: [...getClosingsOverviewMonth],
          hideFields: [],
        },
        closingsOverviewCommunity: {
          masterList: [...getClosingsOverviewCommunity],
          hideFields: [],
        },
        closingsOverviewQuarter: {
          masterList: [...getClosingsOverviewQuarter],
          hideFields: [],
        },
        closingsMyConciergeOverviewBuyers: {
          masterList: [...getClosingsMyConciergeOverviewBuyers],
          hideFields: [],
        },
      },
  reducers: {
    setClosingsOverviewMonthSettings: (state, action) => {
      state.closingsOverviewMonth = parseAction(action.payload);
      setStorageSettings(state);
    },
    setClosingsOverviewCommunitySettings: (state, action) => {
      state.closingsOverviewCommunity = parseAction(action.payload);
      setStorageSettings(state);
    },
    setClosingsOverviewQuarterSettings: (state, action) => {
      state.closingsOverviewQuarter = parseAction(action.payload);
      setStorageSettings(state);
    },
    setClosingsMyConciergeOverviewBuyersSettings: (state, action) => {
      state.closingsMyConciergeOverviewBuyers = parseAction(action.payload);
      setStorageSettings(state);
    },
  },
});

export const getAdminSettings = (state) => state.adminSettings;
export const {
  setClosingsOverviewMonthSettings,
  setClosingsOverviewCommunitySettings,
  setClosingsOverviewQuarterSettings,
  setClosingsMyConciergeOverviewBuyersSettings,
} = AdminSettingsSlice.actions;
export default AdminSettingsSlice.reducer;
